import React from 'react'
import { Route, RouteProps } from 'react-router-dom'
import ErrorBoundaryWrapper from '../ErrorBoundry.component'

interface ProtectedRouteProps extends Omit<RouteProps, 'render'> {
  component: React.ComponentType<any>
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <ErrorBoundaryWrapper>
          <Component {...props} />
        </ErrorBoundaryWrapper>
      )}
    />
  )
}

export default ProtectedRoute
